import { createSelector } from 'reselect';
import _ from 'lodash';
import { getHistoryState } from './utils';
import { getOrder } from './orders';

const getTrackers = createSelector(
  getHistoryState,
  state => state.entities.trackers
);

export const getTrackersForOrder = createSelector(
  getTrackers,
  getOrder,
  (trackers, order) => (
    trackers && order && order.trackers ? _.chain(
      order.trackers
    ).map(
      trackerId => trackers[trackerId]
    ).sortBy(
      t => -Date.parse(t.created)
    ).value() : []
  )
);
